/* Shopify's variant Section Rendering endpoint; GET only. */
(() => {
  'use strict';
  function createPickup({root,request,apply,failed}){
    let revision=0;
    const update=async id=>{
      const current=++revision;
      try{
        const response=await request(root+'variants/'+encodeURIComponent(id)+'/?section_id=liotro-pickup-availability',{credentials:'same-origin'});
        if(!response.ok)throw Error('Pickup response unavailable');
        const html=await response.text();if(current===revision)apply(html);
      }catch(error){if(current===revision)failed(error);}
    };
    update.cancel=()=>revision++;return update;
  }
  const instances=window.LiotroLifecycle.create({selector:'[data-liotro-pickup]',setup(container){
  let selected;
  const update=createPickup({root:cfg.root,request:fetch,apply(html){
    const content=new DOMParser().parseFromString(html,'text/html').querySelector('[data-liotro-pickup-content]');
    if(!content)throw Error('Pickup section missing');container.replaceChildren(...content.childNodes);container.removeAttribute('aria-busy');
  },failed(){
    container.removeAttribute('aria-busy');const message=document.createElement('p');message.className='liotro-native-errors';message.setAttribute('role','status');message.textContent=window.LiotroText('liotro.content.non_riusciamo_a_verificare_il_ritiro_7eef6c')+" ";
    const retry=document.createElement('button');retry.type='button';retry.className='text-link';retry.textContent=window.LiotroText('liotro.invoice.retry');retry.addEventListener('click',()=>update(selected));message.append(retry);container.replaceChildren(message);
  }});
  return {update(id){selected=id;container.replaceChildren();container.setAttribute('aria-busy','true');return update(id);},dispose(){update.cancel();}};
  }});
  document.addEventListener('variant:change',event=>instances.forEach((instance,container)=>{if(!container.dataset.productId||container.dataset.productId===String(event.detail.product.id))instance.update(event.detail.variant.id);}));
  window.LiotroPickup={createPickup,mount:instances.mount,unmount:instances.unmount};instances.mount(document);
})();
